import { request } from './client';
import type { OkResponse } from '@/types/api';
import type {
  AdminUser,
  CreateUserRequest,
  MeResponse,
  PermissionCatalog,
  Role,
  RoleRequest,
  UpdateUserRequest,
} from '@/types/auth';

const AUTH = '/api/admin/auth';

/** REST админ-юзеров/ролей/каталога прав (login/refresh живут в auth-сторе). */
export const authApi = {
  me: () => request<MeResponse>(`${AUTH}/me`),
  permissionCatalog: () => request<PermissionCatalog>(`${AUTH}/permission-catalog`),

  /** Смена собственного пароля (доступна любому авторизованному пользователю). */
  changeOwnPassword: (currentPassword: string, newPassword: string) =>
    request<OkResponse>(`${AUTH}/password`, {
      method: 'POST',
      body: { currentPassword, newPassword },
    }),

  // Users
  listUsers: () => request<AdminUser[]>(`${AUTH}/users`),
  createUser: (body: CreateUserRequest) =>
    request<OkResponse>(`${AUTH}/users`, { method: 'POST', body }),
  updateUser: (id: number, body: UpdateUserRequest) =>
    request<OkResponse>(`${AUTH}/users/${id}`, { method: 'PUT', body }),
  setUserPassword: (id: number, password: string) =>
    request<OkResponse>(`${AUTH}/users/${id}/password`, { method: 'PUT', body: { password } }),
  deleteUser: (id: number) =>
    request<OkResponse>(`${AUTH}/users/${id}`, { method: 'DELETE' }),

  // Roles
  listRoles: () => request<Role[]>(`${AUTH}/roles`),
  createRole: (body: RoleRequest) =>
    request<OkResponse>(`${AUTH}/roles`, { method: 'POST', body }),
  updateRole: (id: number, body: RoleRequest) =>
    request<OkResponse>(`${AUTH}/roles/${id}`, { method: 'PUT', body }),
  deleteRole: (id: number) =>
    request<OkResponse>(`${AUTH}/roles/${id}`, { method: 'DELETE' }),
};
